var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`dashboard__stats_box dashboard__stats_box--${_vm.status}`,attrs:{"data-active":_vm.getSelectedInvitation.type === _vm.status},on:{"click":function($event){return _vm.handleSelectInvitation(_vm.status)}}},[_c('h6',[_vm._v(_vm._s(_vm.text))]),_c('br'),_c('p',[_vm._v(_vm._s(_vm.statusCount))])])
}
var staticRenderFns = []

export { render, staticRenderFns }